import * as React from 'react';
import { Formik } from 'formik';
import { AnswerReviewFilterForm, AnswerReviewFilterFormFields } from '../types';
import CheckboxGroup from './checkbox_group';
import RadioGroup from './radio_group';
import { Collapse } from 'react-bootstrap';

interface Props {
  initialValues: AnswerReviewFilterForm;
  options: AnswerReviewFilterFormFields;
  onChange: (newFormValues: AnswerReviewFilterForm) => void;
  showingStudentAnswers: boolean;
}

const MAX_SUBJECTS_BEFORE_COLLAPSE = 8;
export default class AnswerReviewForm extends React.Component<Props> {
  state = {
    showMoreSubjects: this.props.initialValues.review.subjectTagIds.length > MAX_SUBJECTS_BEFORE_COLLAPSE
  };

  render() {
    const props = this.props;

    return (
      <Formik
        initialValues={props.initialValues}
        onSubmit={async (values, actions) => {
          await this.props.onChange(values);
          actions.setSubmitting(false);
        }}
        // disable validations because calling submitForm() immediately
        // after setFieldValue is preventing the form from submitting
        validateOnBlur={false}
        validateOnChange={false}>
        {bag => {
          // There isn't a top level form onChange event so I made this
          // createChangeHandler function that submits the form whenever
          // the inputs have changed
          let createChangeHandler = fieldName => {
            return newValues => {
              bag.setFieldValue(fieldName, newValues);
              bag.submitForm();
            };
          };
          return (
            <div className="row u-padding-A-s bg-gray-lightest">
              <div className="col-sm-3">
                <RadioGroup
                  label="Date"
                  name="review[after]"
                  optionsArray={props.options.after}
                  selected={bag.values.review.after}
                  onChange={createChangeHandler('review.after')}
                />
                <CheckboxGroup
                  label="Result"
                  name="review[correct]"
                  optionsArray={props.options.correct}
                  selected={bag.values.review.correct}
                  onChange={createChangeHandler('review.correct')}
                />
                <CheckboxGroup
                  label="Difficulty"
                  name="review[difficulties]"
                  optionsArray={props.options.difficulties}
                  selected={bag.values.review.difficulties}
                  onChange={createChangeHandler('review.difficulties')}
                />
              </div>
              <div className="col-sm-3">
                {
                  this.props.showingStudentAnswers ? null :
                    <CheckboxGroup
                      label="Log Entry"
                      name="review[error_log_tag_ids]"
                      optionsArray={props.options.errorLogTags}
                      selected={bag.values.review.errorLogTagIds}
                      onChange={createChangeHandler('review.errorLogTagIds')}
                    />
                }
                <CheckboxGroup
                  label="Marking"
                  name="review[marking]"
                  optionsArray={props.options.marking}
                  selected={bag.values.review.marking}
                  onChange={createChangeHandler('review.marking')}
                />
                <CheckboxGroup
                  label={this.props.showingStudentAnswers ? 'Pace' : 'Your Pace'}
                  name="review[slow]"
                  optionsArray={props.options.slow}
                  selected={bag.values.review.slow}
                  onChange={createChangeHandler('review.slow')}
                />
              </div>
              <div className="col-sm-3">
                <fieldset className="inputs">
                  <div className="controls input-group-label">
                    <b>Section</b>
                  </div>
                  {props.options.examSectionGroups.map(sectionGroup => (
                    <CheckboxGroup
                      key={sectionGroup.displayName}
                      label={sectionGroup.displayName}
                      name="review[exam_section_ids]"
                      optionsArray={sectionGroup.examSections}
                      selected={bag.values.review.examSectionIds}
                      onChange={createChangeHandler('review.examSectionIds')}
                    />
                  ))}
                </fieldset>
              </div>
              <div className="col-sm-3">
                <CheckboxGroup
                  label="Subject"
                  name="review[subject_tag_ids]"
                  optionsArray={props.options.subjectTags.slice(0, MAX_SUBJECTS_BEFORE_COLLAPSE)}
                  selected={bag.values.review.subjectTagIds}
                  onChange={createChangeHandler('review.subjectTagIds')}
                />
                {props.options.subjectTags.length > MAX_SUBJECTS_BEFORE_COLLAPSE && (
                  <a onClick={() => this.setState({ showMoreSubjects: !this.state.showMoreSubjects })}>
                    show more subjects [{this.state.showMoreSubjects ? '-' : '+'}]
                  </a>
                )}
                <Collapse in={this.state.showMoreSubjects} unmountOnExit={false}>
                  <div>
                    <CheckboxGroup
                      label={null}
                      name="review[subject_tag_ids]"
                      optionsArray={props.options.subjectTags.slice(MAX_SUBJECTS_BEFORE_COLLAPSE)}
                      selected={bag.values.review.subjectTagIds}
                      onChange={createChangeHandler('review.subjectTagIds')}
                    />
                  </div>
                </Collapse>
              </div>
            </div>
          );
        }}
      </Formik>
    );
  }
}
